import ConfirmationService from './services';
import ConfirmationTypes from './types';

export const changeConfirmationCoproducerStatus = (values: any) =>
  ConfirmationTypes.confirmCoproducer.createAction(() => ConfirmationService.changeCoproducerStatus(values));
